import { Tokens } from '@tmov/design-system/theme/types';
import styled from 'styled-components';

export const Container = styled.div`
  gap: 32px;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr 3fr;
`;

export const StatsCard = styled.div`
  padding: 24px;

  border-radius: 8px;
  background: ${Tokens.eixods.colors.neutral.grey[0]};

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const IconContainer = styled.div`
  width: 56px;
  height: 56px;

  border-radius: 50%;
  color: ${Tokens.eixods.colors.brand.primary[100]};
  background: ${Tokens.eixods.colors.brand.primary[1]};

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StatsTextContainer = styled.div`
  gap: 4px;
  text-align: center;

  p {
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: ${Tokens.eixods.colors.neutral.grey[70]};
  }

  h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 130%;
    color: ${Tokens.eixods.colors.neutral.grey[100]};
  }
`;

export const MedidaHeader = styled.h3`
  margin: 0;
  width: 100%;
  text-align: left;
  font-weight: 700;
  font-size: 16px;
  line-height: 130%;
  color: ${Tokens.eixods.colors.neutral.grey[100]};
`;
